import { useEffect } from "react";

/**
 * @component DisableCopyPasteDevTools
 * @description
 * Hook React que bloquea acciones comunes del teclado y del mouse relacionadas
 * con copiar, pegar, inspeccionar y abrir herramientas de desarrollo (DevTools).
 *
 * Este componente no renderiza nada en el DOM, pero al montarse en el árbol React,
 * previene las siguientes acciones:
 * - Clic derecho (menú contextual)
 * - Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + U
 * - F12
 * - Ctrl + Shift + I, J, C, K
 *
 * También bloquea los eventos de copiar (`copy`) y pegar (`paste`) directamente.
 *
 * @returns {null} Este componente no renderiza ningún elemento.
 */
const DisableCopyPasteDevTools = () => {
	useEffect(() => {
		/**
		 * Bloquea el menú contextual del navegador al hacer clic derecho.
		 * @param {MouseEvent} event
		 */
		const handleContextMenu = (event) => {
			event.preventDefault();
		};

		/**
		 * Bloquea combinaciones de teclas como Ctrl + C, F12, Ctrl + Shift + I, etc.
		 * @param {KeyboardEvent} event
		 */
		const handleKeyDown = (event) => {
			if (
				(event.ctrlKey && ["c", "v", "x", "u"].includes(event.key.toLowerCase())) ||
				event.key === "F12" ||
				(event.ctrlKey && event.shiftKey && ["i", "j", "c", "k"].includes(event.key.toLowerCase()))
			) {
				event.preventDefault();
			}
		};

		/**
		 * Bloquea eventos de copiar o pegar directamente.
		 * @param {ClipboardEvent} event
		 */
		const handleCopyPaste = (event) => {
			event.preventDefault();
		};

		document.addEventListener("contextmenu", handleContextMenu);
		document.addEventListener("keydown", handleKeyDown);
		document.addEventListener("copy", handleCopyPaste);
		document.addEventListener("paste", handleCopyPaste);

		// Limpieza al desmontar el componente
		return () => {
			document.removeEventListener("contextmenu", handleContextMenu);
			document.removeEventListener("keydown", handleKeyDown);
			document.removeEventListener("copy", handleCopyPaste);
			document.removeEventListener("paste", handleCopyPaste);
		};
	}, []);

	return null;
};

export default DisableCopyPasteDevTools;